import React, { useMemo, useState } from 'react';

import { CompareButtons, CompareChartsCard, CorrelateChartsCard, Modal } from '@components/common';

import { prepareChartsWithKpiTags } from '@utils/kpi-utils/prepareChartData';

import { ICompareSectionTypes } from './CompareSection.types';

import {
	COUNT_OF_CORRELATE_CHARTS,
	MIN_COUNT_OF_COMPARE_CHARTS,
} from '@constants/KPI/kpi-common';
import { MODAL_WIDTH_880 } from '@constants/modals';

const CompareSection = ({
	clearCompareCharts,
	clearCorrelateCharts,
	compareCharts,
	compareDrillDownCharts,
	compareSettings,
	correlateCharts,
	correlation,
	exportCompareCharts,
	exportCorrelateCharts,
	getCorrelation,
	getDrillDownCompareCharts,
	isLoadingCorrelation,
	isLoadingDrillDownCompareCharts,
	classNameCompareSection,
}: ICompareSectionTypes) => {

	const [isOpenCompareModal, setIsOpenCompareModal] = useState(false);
	const [isOpenCorrelateModal, setIsOpenCorrelateModal] = useState(false);

	const isDisabledCompare = compareCharts.length < MIN_COUNT_OF_COMPARE_CHARTS;
	const isDisabledCorrelate = correlateCharts.length < COUNT_OF_CORRELATE_CHARTS;

	const toggleCompareModal = () => compareCharts.length >= MIN_COUNT_OF_COMPARE_CHARTS
		&& setIsOpenCompareModal(prevState => !prevState);

	const toggleCorrelateModal = () => correlateCharts.length >= COUNT_OF_CORRELATE_CHARTS - 1
		&& setIsOpenCorrelateModal(prevState => !prevState);

	const preparedCompareChartsWithTags = useMemo(() => prepareChartsWithKpiTags(compareCharts), [compareCharts]);
	const preparedCompareDrillDownChartsWithTags = useMemo(() =>
		prepareChartsWithKpiTags(compareDrillDownCharts), [compareDrillDownCharts]);

	const preparedCorrelateChartsWithTags = useMemo(() => prepareChartsWithKpiTags(correlateCharts), [correlateCharts]);

	return (
		<>
			<Modal
				height='95%'
				isOpen={!!(isOpenCompareModal && compareCharts.length)}
				isScrollableContent
				onClose={toggleCompareModal}
				title='Comparison'
				width='95%'
			>
				<CompareChartsCard
					compareCharts={preparedCompareChartsWithTags}
					compareDrillDownCharts={preparedCompareDrillDownChartsWithTags}
					compareSettings={compareSettings}
					exportCompareCharts={exportCompareCharts}
					getDrillDownCompareCharts={getDrillDownCompareCharts}
					isLoadingDrillDownCompareCharts={isLoadingDrillDownCompareCharts}
				/>
			</Modal>

			<Modal
				isOpen={!!(isOpenCorrelateModal && correlateCharts.length)}
				isScrollableContent
				onClose={toggleCorrelateModal}
				title={`Correlation is ${correlation}`}
				width={MODAL_WIDTH_880}
			>
				<CorrelateChartsCard
					correlateCharts={preparedCorrelateChartsWithTags}
					exportCorrelateCharts={exportCorrelateCharts}
					getCorrelation={getCorrelation}
					isLoadingCorrelation={isLoadingCorrelation}
				/>
			</Modal>
			<CompareButtons
				classNameCompareSection={classNameCompareSection}
				clearCompare={clearCompareCharts}
				clearCorrelate={clearCorrelateCharts}
				countOfCompareCharts={compareCharts.length}
				countOfCorrelateCharts={correlateCharts.length}
				isDisabledCompare={isDisabledCompare}
				isDisabledCorrelate={isDisabledCorrelate}
				openCompareModal={toggleCompareModal}
				openCorrelateModal={toggleCorrelateModal}
			/>
		</>
	);
};

export default CompareSection;
